module.exports = __webpack_public_path__ + "media/images/abner_contato-41a24b94ad89391671019aa76029d713.png";